export enum SearchType {
    all = "all",
    car = "car",
    wagon = "wagon",
    moto = "moto",
    allroad = "allroad",
    truck = "truck",
    tractor = "tractor",
    industrial = "industrial",
    other = "other",
    parts = "parts",
    oportunities = "oportunities",
}

export enum SearchTypeTitle {
    all = "search_item_all_title",
    car = "search_item_car_title",
    wagon = "search_item_wagon_title",
    moto = "search_item_moto_title",
    allroad = "search_item_allroad_title",
    truck = "search_item_truck_title",
    tractor = "search_item_tractor_title",
    industrial = "search_item_industrial_title",
    other = "search_item_other_title",
    parts = "search_item_parts_title",
    oportunities = "search_item_oportunities_title",
}

export const searchTypePath = new Map<SearchType, string>([
    [SearchType.all, "main"],
    [SearchType.car, "car"],
    [SearchType.wagon, "van"],
    [SearchType.moto, "moto-scooter"],
    [SearchType.allroad, "4x4"],
    [SearchType.truck, "truck"],
    [SearchType.tractor, "tractor"],
    [SearchType.industrial, "agro-industrial"],
    [SearchType.other, "other"],
    [SearchType.parts, "parts"],
    [SearchType.oportunities, "oportunities"],
]);

export const searchTypeParam = new Map<string, SearchType>([
    ["main", SearchType.all],
    ["car", SearchType.car],
    ["van", SearchType.wagon],
    ["moto-quad", SearchType.moto],
    ["moto-scooter", SearchType.moto],
    ["4x4", SearchType.allroad],
    ["truck", SearchType.truck],
    ["tractor", SearchType.tractor],
    ["industrial", SearchType.industrial],
    ["agro-industrial", SearchType.industrial],
    ["other", SearchType.other],
    ["parts", SearchType.parts],
    ["oportunities", SearchType.oportunities],
]);

export const searchTypeDeTransform = new Map<SearchType, string>([
    [SearchType.all, "ALL"],
    [SearchType.car, "TURISMO"],
    [SearchType.wagon, "CAMIONETA"],
    [SearchType.moto, "MOTO"],
    [SearchType.allroad, "4X4"],
    [SearchType.truck, "CAMION"],
    [SearchType.tractor, "AGRICOLA"],
    [SearchType.industrial, "INDUSTRIAL"],
    [SearchType.other, "OTROSPRODUCTOS"],
    [SearchType.oportunities, "OPORTUNIDADES"],
]);

export const searchTypeToAPI = new Map<SearchType, string>([
    [SearchType.all, "ALL"],
    [SearchType.car, "GRUPOAUTO"],
    [SearchType.wagon, "GRUPOAUTO"],
    [SearchType.moto, "MOTO"],
    [SearchType.allroad, "GRUPOAUTO"],
    [SearchType.truck, "CAMION"],
    [SearchType.tractor, "AGROINDUSTRIAL"],
    [SearchType.industrial, "AGROINDUSTRIAL"],
    [SearchType.other, "OTROSPRODUCTOS"],
    [SearchType.oportunities, "OPORTUNIDADES"],
]);

export const searchTypeTransform = new Map<string, SearchType>([
    ["ALL", SearchType.all],
    ["TURISMO", SearchType.car],
    ["CAMIONETA", SearchType.wagon],
    ["MOTO", SearchType.moto],
    ["4X4", SearchType.allroad],
    ["CAMION", SearchType.truck],
    ["AGRICOLA", SearchType.tractor],
    ["INDUSTRIAL", SearchType.industrial],
    ["OTROSPRODUCTOS", SearchType.other],
    // ['PARTS', SearchType.parts],
    ["OPORTUNIDADES", SearchType.oportunities],
]);

export const searchTypeMenu = new Map<string, SearchType>([
    ["verBusquedaTodos", SearchType.all],
    ["verBusquedaTursimo", SearchType.car],
    ["verBusquedaCamioneta", SearchType.wagon],
    ["verBusquedaMoto", SearchType.moto],
    ["verBusqueda4por4", SearchType.allroad],
    ["verBusquedaCamion", SearchType.truck],
    ["verBusquedaAgricola", SearchType.tractor],
    ["verBusquedaIndustrial", SearchType.industrial],
    ["verBusquedaOtrosproductos", SearchType.other],
    ["verObsoletos", SearchType.oportunities],
    ["verBusquedaSinResultado", SearchType.parts],
]);

export enum SearchTypeSEO {
    all = "Grupo Soledad B2B | Expertos en distribución de neumático profesional",
    car = "Grupo Soledad B2B | Tus neumáticos de turismo de calidad",
    wagon = "Grupo Soledad B2B | Los mejores neumáticos de camioneta",
    moto = "Grupo Soledad B2B | Lo mejor en neumáticos de moto y quad",
    allroad = "Grupo Soledad B2B | Neumático profesional 4x4",
    truck = "Grupo Soledad B2B | Profesionales de neumático del camión",
    tractor = "Grupo Soledad B2B | Variedad de neumático agrícola",
    industrial = "Grupo Soledad B2B | Neumáticos industriales primeras marcas",
    other = "Grupo Soledad B2B | Cámaras, cadenas, baterías, aceites y más",
    parts = "Grupo Soledad B2B | Otras piezas, recambios de automóvil",
    oportunities = "Grupo Soledad B2B | Ofertas exclusivas de neumáticos",
}
